<template>
    <section>
      <header-com v-if='!byadmin'/>
      <div class="container">
        <div class="fixed-block"></div>

        <div class="mb30"><order-module-title title="基本信息"/></div>
        <div class="basic info f28">
          <div>
            <span class="grey6">分类：</span>
            <span>{{detail.category}}</span>
          </div>
          <div>
            <span class="grey6">品牌：</span>
            <span>{{detail.brand}}</span>
          </div>
          <div>
            <span class="grey6">颜色：</span>
            <span>{{detail.color}}</span>
          </div>
          <div>
            <span class="grey6">款式：</span>
            <span>{{detail.style == 1?'男款':'女款'}}</span>
          </div>
        </div>
        <div class="block"></div>
        <div class="tabs f32">
          <div
            class="tab"
            :class="defaultIndex === 0 ? 'tab-actived' : ''"
            @click="defaultIndex = 0"
          >诊断方案
            <div class='bottom_line' v-show="defaultIndex === 0"></div>
          </div>
          <div
            class="tab"
            :class="defaultIndex === 1 ? 'tab-actived' : ''"
            @click="defaultIndex = 1"
          >宝贝相册
            <div class='bottom_line' v-show="defaultIndex === 1"></div>
          </div>
        </div>
        <div class="tabs-container">
          <diagnosis v-if="defaultIndex === 0 && !makeCheck()" :model='detail' />
          <photos v-if="defaultIndex === 1" :model='photos'/>
          <no-repair v-if="makeCheck() && defaultIndex === 0" :model='detail'/>
        </div>
      </div>
      <!-- <div class='btn_content'>
        
      </div>   -->
      <img src='/images/public/uppage.png' class='pageUp' @click='page(0)' v-if='showIndex != 0'>
      <img src='/images/public/downpage.png'  class='pageDown' @click='page(1)' v-if='showIndex != idIndex.length-1'>
    </section>
</template>

<script>
  import orderApi from '@/axios/order'
  import diagnosis from './diagnosis'
  import photos from './photos'
  import noRepair from './noRepair'
  export default {
    name: 'index',
    data () {
      return {
        id : '',
        goodsCode : '',
        defaultIndex: 0,
        isCanRepair: false,
        detail : {
          goodsCuringServiceBoList : [{
            curingServiceName : ''
          }]
        },
        photos : [],
        byadmin : false,
        idIndex : [],
        showIndex : 0
      }
    },
    created(){
      this.id = this.$route.query.id + '';
      this.goodsCode = this.$route.query.goodsCode;
      if(this.goodsCode){
        //客服查看方案
        this.getDiagnoseByGoodsCode(this.goodsCode);

        this.getPhotosByGoodsCode(this.goodsCode);
        this.byadmin = true;
        return;
      }
      console.log(this.id)
      this.idIndex = this.id.split(',');
      this.setIndexAction();

    },
    components: {
      diagnosis,
      photos,
      noRepair
    },
    computed:{
      
    },
    methods : {
      setIndexAction(){
        this.getDiagnose(this.idIndex[this.showIndex]);
        this.getPhotos(this.idIndex[this.showIndex]);
      },
      page(index){
        if(index){
          this.showIndex++; 
        }else{
          this.showIndex--; 
        }

        this.setIndexAction();
      },
      getDiagnoseByGoodsCode(code){
        orderApi.getDiagnoseByGoodcode(code).then((res)=>{
          this.detail = res;
        })
      },
      getPhotosByGoodsCode(code){
        orderApi.getPhotosByGoodsCode(code).then((res)=>{
          this.photos = res;
        })
      },
      makeCheck(){
        if(this.detail.goodsCuringServiceBoList[0]){
          if(this.detail.goodsCuringServiceBoList[0].curingServiceName == '无法修复'){
            return true;    
          } 
        }
        return false;
      },
      getPhotos(id){
        let _this = this;
        orderApi.getPhotos(id).then((res)=>{
          this.photos = res;
        })
      },
      changeArr(res){
        console.log(res.goodsCuringServiceRepairPointBoList)
        let obj = {};
        let arr = [];
        let noArr = [];
        res.goodsCuringServiceRepairPointBoList.forEach(element => {
          if(element.employStatus){
            arr.push(element)
          }else{
            noArr.push(element)
          }
        });
        obj = res;
        obj.goodsCuringServiceRepairPointBoList = arr.concat(noArr);
        return obj;
      },
      getDiagnose(id){
        orderApi.getDiagnose(id).then((res)=>{
          //增加数据转换
          
          this.detail = this.changeArr(res);
          //如果是客户自己，发送请求
          let params = {
            behaviorType : 11,
            goodsCodeList : res.goodsCode
          }
          orderApi.behavior(params).then((res)=>{
            
          })
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  .basic{
    display: flex;
    flex-wrap: wrap;
    div{
      width: 50%;
      line-height: 40px;
      margin-bottom: 20px;
      &:last-child, &:nth-last-child(2){
        margin-bottom: 0
      }
    }
  }
  .info{
    padding: 0 30px 30px 30px;
  }
  .pageUp,.pageDown{
    width: 100px;
    position: fixed;
    top:50%;
    right: 20px;
  }
  .pageUp{
    margin-top:-50px; 
  }
  .pageDown{
    margin-top:50px; 
  }
  .container{
    display: flex;
    align-items: center;
    flex-direction: column;
    background: #fff;
    padding-top:120px;
    div.fixed-block{
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 116px;
      background: #fff;
    }
    .tabs{
      width: 350px;
      height: 60px;
      border-radius: 12px;
      // border: 2px solid rgba(51,51,51,1);
      display: flex;
      margin-top:48px;
      background: #fff;
      .tab{
        flex: 1;
        text-align: center;
        line-height: 60px;
        
        font-weight: 500;
        color:#999999;
        position: relative;
        .bottom_line{
          width:80px;
          background: #333333;
          height: 8px;
          bottom:-10px;
          border-radius: 4px;
          position: absolute;
          left:50%;
          margin-left: -40px;
        }
        &.tab-actived{
          // background: rgba(51,51,51,1);
          color:#333333;
        }
      }
    }
  }
  .fixed-bottom{
    width: 690px;
    height: 172px;
    position: fixed;
    bottom: 0;
    display: flex;
    left: 30px;
    background: #fff;
    justify-content: space-between;
    button{
      width:330px;
      height:92px;
      border-radius:46px;
      border:2px solid rgba(51,51,51,1);
      color:rgba(51,51,51,1);
      line-height: 92px;
    }
  }
</style>
